import { FunctionComponent, useCallback } from "react";
import { MenuItemWithDescription } from "src/components/Menus/MenuItemWithDescription";
import * as FSQ from "src/generated/hooks/form-service/queries";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { triggerDownload } from "src/services/dataTransfer";

type Props = {
  enrollmentPeriodId: uuid;
};

export const ExportBoundaryConnectionMenuItem: FunctionComponent<Props> = (
  props
) => {
  const { enrollmentPeriodId } = props;

  const toast = useAvelaToast();

  const service = FSQ.useExportSchoolBoundaryConnections(
    {
      path: {
        enrollmentPeriodId,
      },
    },
    ["exportSchoolBoundaryConnections", enrollmentPeriodId],
    {
      enabled: false,
    }
  );

  const handleOnExportClick = useCallback(async () => {
    const loadingToastId = toast({
      title: "Export in progress",
      description: "Download will start shortly",
      status: "loading",
    });

    const response = await service.refetch();

    if (!response.data?.data) {
      toast.genericError();
      return;
    }

    try {
      triggerDownload(
        new Blob(
          [JSON.stringify(response.data?.data.connections, undefined, 2)],
          {
            type: "application/json",
          }
        ),
        "enrollmentPeriodSchoolBoundaryConnections.json"
      );
      toast.close(loadingToastId);
      toast({
        title: "Enrollment period boundary connections exported",
        status: "success",
      });
    } catch (e) {
      toast.close(loadingToastId);
      toast.error({
        title: "Something went wrong!",
        description: "Check your network and try again",
      });
      console.error(e);
    }
  }, [toast, service]);

  return (
    <MenuItemWithDescription
      title="Boundaries to JSON file"
      description="Export boundary connections to a file"
      onClick={handleOnExportClick}
    />
  );
};
